import React from "react";

import { useStaticEntries } from "@/hooks/firestore/betting/useEntries";
import { Entry } from "@/features/entries/components/Entry";
import { EntrySkeleton } from "@/features/entries/components/pages/EntrySkeleton";
import { ReactComponent as SettledIcon } from "@/features/entries/assets/settled.svg";
import { PageMessage } from "@picklebet/ui";
import { StatusMessage } from "@/features/betslip/components/StatusMessage";
import NextBettingButtons from "@/features/shell/components/shared/NextBettingButtons";
import { useIsMobile } from "@/hooks/useDisplay";

import * as styles from "./BetsList.module.scss";

const SettledBets = () => {
  const { entries, isLoading } = useStaticEntries(10);
  const isMobile = useIsMobile();
  const btnVariant = isMobile ? "primary" : "blurred";

  if (isLoading) {
    return <EntrySkeleton />;
  }

  if (!entries?.length) {
    return (
      <StatusMessage>
        <PageMessage
          className={styles.entryMessage}
          image={<SettledIcon />}
          title={`No Settled Entries`}
          subTitle={`Check out today's action to make a bet`}
        >
          <NextBettingButtons
            className={styles.entryButtons}
            variant={btnVariant}
            size="md"
          />
        </PageMessage>
      </StatusMessage>
    );
  }

  return (
    <div className={styles.entries}>
      {entries.map((entry) => (
        <Entry key={entry.entryId} entry={entry} isCompact />
      ))}
    </div>
  );
};

export default SettledBets;
